import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import GatheringCard from "@/components/site/GatheringCard";
import { FadeUp, MaskReveal } from "@/components/site/Reveal";
import { getGatherings } from "@/data/gatherings";

export default function Gatherings() {
  const gatherings = getGatherings();

  return (
    <main className="min-h-screen bg-gaia-bg" data-testid="gatherings-page">
      <Navigation solid />

      {/* Intro */}
      <section className="gaia-grain mx-auto max-w-3xl px-6 pb-8 pt-32 text-center md:px-12 md:pb-10 md:pt-36">
        <FadeUp>
          <span className="font-sans text-[11px] uppercase tracking-[0.36em] text-gaia-taupe" data-testid="gatherings-eyebrow">
            Gatherings
          </span>
        </FadeUp>
        <MaskReveal
          as="h1"
          lines={["A living archive of", "Gaia Space."]}
          className="mx-auto mt-6 font-serif text-4xl font-light leading-[1.08] tracking-tight text-gaia-charcoal md:text-6xl"
          data-testid="gatherings-title"
        />
        <FadeUp delay={0.15}>
          <p className="mx-auto mt-7 max-w-xl font-sans text-base font-light leading-relaxed text-gaia-charcoal/70">
            A collection of meaningful experiences — evenings of movement, breath, music and
            connection. Some have already unfolded; others are still being dreamed into being.
            This is where the story of our community is written, one gathering at a time.
          </p>
        </FadeUp>
      </section>

      {/* Cards */}
      <section className="mx-auto max-w-6xl px-6 pb-20 md:px-12 md:pb-28">
        <div className="flex flex-wrap justify-center gap-x-10 gap-y-12" data-testid="gatherings-grid">
          {gatherings.map((g, i) => (
            <div key={g.slug} className="w-full sm:w-[340px] lg:w-[360px]">
              <GatheringCard gathering={g} index={i} />
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </main>
  );
}
